import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Row, Column, Item } from '@mui-treasury/components/flex';
import { Grid, Button, Avatar } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';


const useBasicProfileStyles = makeStyles(({ palette }) => ({
    avatar: {
        borderRadius: 8,
        backgroundColor: '#495869',
    },
    overline: {
        fontSize: 10,
        textTransform: 'uppercase',
        letterSpacing: 1,
        color: '#8D9CAD',
    },
    name: {
        fontSize: 14,
        fontWeight: 500,
        color: '#495869',
    },
    card: {
        border: '2px solid',
        borderColor: '#ffffff',
        background: '#ffffff',
        borderRadius: 16,
        transition: '0.4s',
        boxShadow: '0px 14px 80px rgba(34, 35, 58, 0.2)',
        '&:hover': {
            borderColor: '#29588F',
        },
    },
    imagen: {
        borderRadius: 16,
    },
    title: {
        fontSize: '1.25rem',
        color: '#122740',
    },
    subheader: {
        fontSize: '0.875rem',
        color: '#495869',
    },
}));

const CompCursoItem = (props) => {
    const styles = useBasicProfileStyles();
    const gap = { xs: 1, sm: 1.5, lg: 2 };
    console.log(props);

    const seleccionarCurso = () => {
        props.history.push(`/temas/${props.item.id}`);
    }

    return (
        <Grid item xs={12} sm={8} lg={6}>
            <Row className={styles.card} p={{ xs: 0.5, sm: 0.75, lg: 1 }} gap={gap}>
                <Item grow >
                    <img src={props.item.imagenCurso} alt="" className={styles.imagen} />
                </Item>
                <Column>
                    <Row>
                        <Item position={'middle'}>
                            <Typography className={styles.title}>
                                <b>{props.item.tituloCurso}</b>
                            </Typography>
                            <Typography className={styles.subheader}>
                                {props.item.descripcionCurso}
                            </Typography>
                        </Item>
                        <Item position={'right'} mr={-0.5}>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            className="button"
                            type="button"
                            startIcon={<PlayCircleFilledWhiteIcon />}
                            onClick={() => seleccionarCurso()}
                        >
                            ACCEDER
                               </Button>
                    </Item>

                    </Row>
                    <Row>
                        <Item><Avatar className={styles.avatar}>P</Avatar></Item>
                        <Item position={'middle'} pl={{ sm: 0.5, lg: 0.5 }}>
                            <Typography className={styles.overline}>PROFESOR</Typography>
                            <Typography className={styles.name}>{props.item.profesorCurso}</Typography>
                        </Item>

                    </Row>
                </Column>
            </Row>
        </Grid>
    );
}
export default withRouter(CompCursoItem)
